var _path, _path2, _path3, _g, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg32DiffuserSteamerPurifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M994.96 456.528L994.184 455.767C996.51 454.5 1000.7 452.421 998.836 454.246C996.975 456.072 995.477 456.528 994.96 456.528Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M979.34 456.528L980.115 455.767C977.79 454.5 973.603 452.421 975.464 454.246C977.324 456.072 978.823 456.528 979.34 456.528Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M978.092 413.5C978.092 415.167 977.332 419 976.808 421C976.631 421.675 976.197 423.069 975.643 424.852C974.051 429.97 971.463 438.292 971.092 442C970.694 445.98 971.592 449 973.664 452C974.892 453.778 978.343 456.966 987.147 456.508C995.951 456.966 999.402 453.778 1000.63 452C1002.7 449 1003.6 445.98 1003.2 442C1002.83 438.292 1000.24 429.97 998.652 424.852C998.097 423.069 997.664 421.675 997.487 421C996.963 419 996.203 415.167 996.203 413.5H989.592H984.703H978.092Z",
    fill: "url(#paint0_radial_1989_6853)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_1989_6853)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 987.15,
    cy: 414.5,
    rx: 9.15,
    ry: 2.5,
    fill: "#B0F6FD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1989_6853)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 987.15,
    cy: 413.5,
    rx: 9.15,
    ry: 2.5,
    fill: "#B0F6FD"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M987.6 452H990.6C991.152 452 991.6 452.448 991.6 453V453C991.6 453.552 991.152 454 990.6 454H987.6V452Z",
    fill: "#F7F7F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M990.6 452H987.6V454H987.8V452.2H990.8C991.025 452.2 991.233 452.275 991.401 452.4C991.218 452.157 990.927 452 990.6 452Z",
    fill: "#E3E3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M987 452H984C983.448 452 983 452.448 983 453V453C983 453.552 983.448 454 984 454H987V452Z",
    fill: "#F6F6F6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M984 452H987V454H986.8V452.2H983.8C983.575 452.2 983.367 452.275 983.2 452.4C983.382 452.157 983.673 452 984 452Z",
    fill: "#E3E3E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1003.19 445.576C1003.18 445.584 1003.17 445.592 1003.16 445.601C1003.06 445.708 1002.89 445.861 1002.65 446.046C1002.17 446.415 1001.38 446.911 1000.19 447.408C997.8 448.401 993.764 449.4 987.195 449.4C980.626 449.4 976.591 448.401 974.202 447.408C973.007 446.911 972.224 446.415 971.741 446.046C971.499 445.861 971.333 445.708 971.227 445.601C971.174 445.548 971.137 445.507 971.113 445.479C971.104 445.469 971.097 445.461 971.092 445.455C971.105 445.568 971.119 445.68 971.135 445.791C971.246 445.899 971.405 446.04 971.619 446.204C972.117 446.585 972.915 447.089 974.125 447.592C976.544 448.599 980.606 449.6 987.195 449.6C993.784 449.6 997.846 448.599 1000.27 447.592C1001.47 447.089 1002.27 446.585 1002.77 446.204C1002.92 446.088 1003.05 445.983 1003.15 445.894C1003.16 445.788 1003.18 445.682 1003.19 445.576Z",
    fill: "#E4E4E4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1003.21 445.348C1003.2 445.364 1003.18 445.382 1003.16 445.401C1003.06 445.507 1002.89 445.661 1002.65 445.845C1002.17 446.215 1001.38 446.711 1000.19 447.208C997.8 448.201 993.764 449.2 987.195 449.2C980.626 449.2 976.591 448.201 974.202 447.208C973.007 446.711 972.224 446.215 971.741 445.845C971.499 445.661 971.333 445.507 971.227 445.401C971.174 445.348 971.137 445.307 971.113 445.279C971.101 445.265 971.092 445.255 971.087 445.248L971.081 445.241L971.08 445.239C971.08 445.239 971.08 445.239 971.07 445.246C971.081 445.352 971.092 445.457 971.105 445.562C971.217 445.673 971.385 445.825 971.619 446.004C972.117 446.385 972.915 446.889 974.125 447.392C976.544 448.398 980.606 449.4 987.195 449.4C993.784 449.4 997.846 448.398 1000.27 447.392C1001.47 446.889 1002.27 446.385 1002.77 446.004C1002.94 445.875 1003.07 445.761 1003.18 445.665C1003.19 445.56 1003.2 445.455 1003.21 445.348Z",
    fill: "#F6F6F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 985,
    y: 416,
    width: 4,
    height: 0.7,
    rx: 0.2,
    fill: "#ACEEFF",
    stroke: "#8AECFD",
    strokeWidth: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_1989_6853",
    x: 974,
    y: 410,
    width: 26.3,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.879167 0 0 0 0 0.989015 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_6853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_6853",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1,
    result: "effect2_foregroundBlur_1989_6853"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1989_6853",
    x: 974,
    y: 409,
    width: 26.3,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.879167 0 0 0 0 0.989015 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1989_6853"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1989_6853",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1989_6853",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(987.5 424.5) rotate(90) scale(25 26.3663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.771351,
    stopColor: "#8BEDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg32DiffuserSteamerPurifier);
export default __webpack_public_path__ + "static/media/32DiffuserSteamerPurifier.865a0fe5f7b447692451d955037c30b1.svg";
export { ForwardRef as ReactComponent };